import React, { useMemo } from 'react';
import { Link } from 'react-router-dom';
import { MaterialReactTable, useMaterialReactTable } from 'material-react-table';
import { Eye } from 'lucide-react';

const QuotationComparison = ({ data }) => {
    const columns = useMemo(
        () => [
            {
                accessorKey: 'indent_date',
                header: 'Date',
                size: '15%',
                Cell: ({ cell }) =>   new Intl.DateTimeFormat('en-GB').format(new Date(cell.getValue())),
            },
            {
                accessorKey: 'indent_number',
                header: 'Indent No.',
                size: '10%',
            },
            {
                accessorKey: 'branch_name',
                header: 'Factory Name',
                size: '15%',
            },
            {
                accessorKey: 'indentItems',
                header: 'Item Titles',
                size: '30%',
                accessorFn: row => row.indentItems.map(item => item.item_title).join(', '), 
                Cell: ({ cell }) => (
                    <div className="max-h-10 overflow-y-auto">
                        {cell.getValue().split(', ').map((title, index) => (
                            <div key={index}>{title}</div>
                        ))}
                    </div>
                ),
            },
            {
                accessorKey: 'indent_remark',
                header: 'Remark',
                size: '10%',
            },
            {
                accessorKey: 'indent_by_name',
                header: 'Indent by name',
                size: '15%',
            },
            {
                accessorKey: '_id',
                header: 'Action',
                size: '5%',
                Cell: ({ cell, row }) => (
                    <Link
                        to={`/quote-comparison-detail/${row.original.unique_group_id}`}
                        className="m-2"
                    >
                        <button><Eye /></button>
                    </Link>
                ),
            },
        ],
        []
    );

    const table = useMaterialReactTable({
        columns,
        data,
        columnFilterDisplayMode: 'popover',
        paginationDisplayMode: 'pages',
    });

    return <MaterialReactTable table={table} />;
}

export default QuotationComparison;